<template>
    <div class="challenge-finalist">
        <div class="image image-border" :class="{ 'inverse': isInverse }"
             :style="{ 'background-image': `url('${imageSrc}')` }">
        </div>
        <h3 class="name">
            {{name}}
        </h3>
        <h4 class="clan-name">
            {{clanName}}
        </h4>
        <div class="wins" v-if="wins">
            {{wins}} wins
        </div>
        <h3 class="prize-money">
            {{prizeMoney}}
        </h3>
    </div>
</template>

<script>
    export default {
        name: "challenge-finalist",
        props: {
            imageSrc: {
                type: String,
                required: true
            },
            isInverse: Boolean,
            name: {
                type: String,
                required: true
            },
            clanName: String,
            wins: Number,
            prizeMoney: {
                type: String,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .challenge-finalist {
        display: grid;
        grid-template-rows: 150px auto auto auto;
        grid-gap: 4px;
        grid-auto-flow: row;

        .image {
            background: no-repeat center;
            background-size: cover;
        }

        .name {
            color: $entelect-orange;
        }

        .wins {
            color: $green;
        }
    }
</style>